import SuperFetch from '../../../superFetch.js';

class RecommendReviewApi {
  /**
   *  [추천 상품 후기 리스트] 추천 상품 후기 리스트 요청하기
   */
  getRecommendReviewList = (data) => SuperFetch.post('/recommend/review/list', data);

  /**
   *  [추천 상품 후기 상세] 추천 상품 후기 상세 요청하기
   */
  getRecommendReviewDetail = (data) => SuperFetch.post('/recommend/review/detail', data);

  /**
   *  추천 상품 후기 복사하기 전 필요한 데이터 가져오기
   */
  prepareCopyRecommendReview = (data) => SuperFetch.post('/recommend/review/insert/preparation/copy', data);

  /**
   *  추천 상품 후기 등록하기 전 필요한 데이터 가져오기
   */
  prepareCreateRecommendReview = (data) => SuperFetch.post('/recommend/review/insert/preparation/insert', data);

  /**
   *  추천 상품 후기에 연결할 아이템 리스트 요청하기
   */
  getRecommendReviewItemList = (data) => SuperFetch.post('/recommend/review/insert/preparation/list', data);

  /**
   *  [추천 상품 후기 등록/복사하기
   */
  createRecommendReview = (data) => SuperFetch.post('/recommend/review/insert', data);

  /**
   *  전체 상품 후기 리스트 EXCEL 다운로드
   */
  getRecommendReviewItemListExcelDownload = (data) =>
    SuperFetch.post('/recommend/review/insert/preparation/list/excel/download', data);

  /**
   *  선택된 상품 후기 리스트 EXCEL 다운로드
   */
  getSelectedRecommendReviewItemListExcelDownload = (data) =>
    SuperFetch.post('/recommend/review/insert/preparation/list/excel/download/selected', data);

  /**
   *  상품 후기 리스트 EXCEL 업로드
   */
  setRecommendReviewItemListExcelUpload = (data) =>
    SuperFetch.post('/recommend/review/insert/preparation/list/excel/upload', data);
}

export default new RecommendReviewApi();
